import styled from "styled-components";

import { FontWeightType } from "@sso/types";

interface AnchorProps {
  color?: string;
  fontSize?: string;
  margin?: string;
  padding?: string;
  fontWeight?: FontWeightType;
  width?: string;
  textAlign?: "center" | "left" | "right";
}
export const Anchor = styled.a<AnchorProps>`
  text-decoration: none;
  color: ${p => p.color || p.theme.colors.text.primary};
  ${p => p.width && `width:${p.width}`};
  ${p => p.fontSize && `font-size:${p.fontSize}`};
  ${p => p.margin && `margin:${p.margin}`};
  ${p => p.padding && `padding:${p.padding}`};
  ${p => p.fontWeight && `font-weight:${p.fontWeight}`};
  ${p => p.textAlign && `text-align:${p.textAlign}`};
`;
